import { useProfile } from '@/hooks';

import Frame2Icon from '../assets/icons/frame-2.svg?react';
import Subtract4Icon from '../assets/icons/subtract-4.svg?react';
import SubtractIcon from '../assets/icons/subtract.svg?react';

export const ClientBonusPage = () => {
  const profile = useProfile(true);
  const bonusBalance = profile?.bonus_balance ?? 15000;
  const formattedBonus = bonusBalance.toLocaleString('ru-RU');

  return (
    <div className="relative inline-flex flex-[0_0_auto] flex-col items-start gap-6 overflow-hidden">
      <div className="relative inline-flex flex-[0_0_auto] flex-col items-start rounded-3xl bg-[linear-gradient(162deg,rgba(119,194,242,1)_0%,rgba(211,228,239,1)_100%),linear-gradient(159deg,rgba(97,242,225,1)_0%,rgba(69,249,205,1)_50%,rgba(218,255,234,1)_100%),linear-gradient(0deg,rgba(21,21,21,1)_0%,rgba(21,21,21,1)_100%)]">
        <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-8 rounded-[16px_16px_0px_0px] bg-white px-0 py-6 md:w-[968px]">
          <div className="relative flex w-full flex-[0_0_auto] flex-col items-start justify-center gap-6 self-stretch px-6 py-0">
            <p className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.5rem] font-bold leading-9 tracking-normal text-[#151515]">
              Как копить и использовать бонусы
            </p>

            <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-[24px] self-stretch overflow-hidden rounded-2xl bg-[#0788f1]">
              <div className="relative flex w-full flex-[0_0_auto] items-center gap-5 self-stretch p-8">
                <Subtract4Icon className="relative size-[72px]" />

                <div className="relative inline-flex flex-[0_0_auto] flex-col items-center justify-center">
                  <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1rem] font-normal leading-6 tracking-normal text-white">
                    доступно бонусных баллов
                  </div>

                  <div className="relative self-stretch text-[2.5rem] font-bold leading-[3rem] tracking-normal text-white">
                    {formattedBonus}
                  </div>
                </div>
              </div>
            </div>

            <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-3 self-stretch">
              <div className="relative flex w-full flex-[0_0_auto] items-start gap-4 self-stretch">
                <div className="relative flex flex-1 grow items-baseline gap-2">
                  <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.25rem] font-medium leading-[1.875rem] tracking-normal text-[#151515]">
                    Как заработать бонусы
                  </div>
                </div>
              </div>

              <div className="relative flex w-full flex-[0_0_auto] items-start gap-[24px] self-stretch">
                <div className="relative flex flex-1 grow flex-col items-start gap-2 self-stretch overflow-hidden rounded-2xl bg-[#0788f114] p-5">
                  <div className="relative inline-flex flex-[0_0_auto] items-center gap-1.5 rounded-[100px] bg-[linear-gradient(35deg,rgba(7,136,241,1)_0%,rgba(122,124,251,1)_100%)] px-4 py-1.5">
                    <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.5rem] font-bold leading-8 tracking-normal text-white">
                      5%
                    </div>
                  </div>

                  <div className="relative w-fit whitespace-nowrap text-[1rem] font-normal leading-6 tracking-normal text-[#151515]">
                    от суммы каждого заказа
                  </div>
                </div>

                <div className="relative flex flex-1 grow flex-col items-start gap-2 self-stretch overflow-hidden rounded-2xl bg-[#0788f114] p-5">
                  <div className="relative inline-flex flex-[0_0_auto] items-center gap-1.5 rounded-[100px] bg-[linear-gradient(35deg,rgba(7,136,241,1)_0%,rgba(122,124,251,1)_100%)] px-4 py-1.5">
                    <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.5rem] font-bold leading-8 tracking-normal text-white">
                      +100
                    </div>

                    <SubtractIcon className="relative size-5" />
                  </div>

                  <div className="relative inline-flex flex-[0_0_auto] flex-col items-start">
                    <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1rem] font-normal leading-6 tracking-normal text-[#151515]">
                      бонусов за каждого друга
                    </div>

                    <div className="relative w-fit whitespace-nowrap text-[1rem] font-medium leading-6 tracking-normal text-[#0788f1]">
                      Пригласить друга
                    </div>
                  </div>
                </div>

                <div className="relative flex flex-1 grow flex-col items-start gap-2 overflow-hidden rounded-2xl bg-[#0788f114] p-5">
                  <div className="relative inline-flex flex-[0_0_auto] items-center gap-1.5 rounded-[100px] bg-[linear-gradient(35deg,rgba(7,136,241,1)_0%,rgba(122,124,251,1)_100%)] px-4 py-1.5">
                    <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.5rem] font-bold leading-8 tracking-normal text-white">
                      +1000
                    </div>

                    <SubtractIcon className="relative size-5" />
                  </div>

                  <p className="relative self-stretch text-[1rem] font-normal leading-6 tracking-normal text-[#151515]">
                    за добавление рецепта или схемы лечения
                  </p>
                </div>
              </div>
            </div>

            <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-3 self-stretch">
              <div className="relative flex w-full flex-[0_0_auto] items-start gap-4 self-stretch">
                <div className="relative flex flex-1 grow items-baseline gap-2">
                  <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[1.25rem] font-medium leading-[1.875rem] tracking-normal text-[#151515]">
                    Как потратить бонусы
                  </div>
                </div>
              </div>

              <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-[24px] self-stretch">
                <div className="relative flex w-full flex-[0_0_auto] items-start gap-6 self-stretch overflow-hidden rounded-2xl bg-[#f1f7fa] p-5">
                  <div className="relative flex size-8 items-center justify-center overflow-hidden rounded-[133px] bg-white">
                    <div className="whitespace-nowrap text-center text-[1rem] font-normal leading-6 tracking-normal text-[#151515] opacity-40">
                      1
                    </div>
                  </div>

                  <div className="relative flex flex-1 grow flex-col items-start gap-2">
                    <p className="relative mt-[-1.00px] self-stretch text-[1.25rem] font-medium leading-7 tracking-normal text-black">
                      При оформлении нового заказа вы видите свой баланс и
                      доступную сумму к списанию
                    </p>

                    <p className="relative w-fit whitespace-nowrap text-[1rem] font-normal leading-6 tracking-normal text-[#151515] opacity-50">
                      Списание возможно только в пределах установленного
                      процента от суммы заказа
                    </p>
                  </div>
                </div>

                <div className="relative flex w-full flex-[0_0_auto] items-center gap-6 self-stretch overflow-hidden rounded-2xl bg-[#f1f7fa] p-5">
                  <div className="relative flex size-8 items-center justify-center overflow-hidden rounded-[133px] bg-white">
                    <div className="whitespace-nowrap text-center text-[1rem] font-normal leading-6 tracking-normal text-[#151515] opacity-40">
                      2
                    </div>
                  </div>

                  <p className="relative w-fit whitespace-nowrap text-[1.25rem] font-medium leading-7 tracking-normal text-black">
                    Бонусы списываются автоматически при оплате
                  </p>
                </div>

                <div className="relative flex w-full flex-[0_0_auto] items-center gap-6 self-stretch overflow-hidden rounded-2xl bg-[#f1f7fa] p-5">
                  <div className="relative flex size-8 items-center justify-center overflow-hidden rounded-[133px] bg-white">
                    <div className="whitespace-nowrap text-center text-[1rem] font-normal leading-6 tracking-normal text-[#151515] opacity-40">
                      4
                    </div>
                  </div>

                  <p className="relative w-fit whitespace-nowrap text-[1.25rem] font-medium leading-7 tracking-normal text-black">
                    Если заказ отменён или возвращён — бонусы возвращаются на
                    счёт
                  </p>
                </div>
              </div>
            </div>

            <div className="relative flex w-full flex-[0_0_auto] items-center justify-center gap-5 self-stretch rounded-2xl bg-[#f1f7fa] px-5 py-4">
              <Frame2Icon className="relative flex-[0_0_auto]" />

              <p className="relative mt-[-1.00px] flex-1 text-[0.875rem] font-normal leading-[1.125rem] tracking-normal text-transparent">
                <span className="text-[#151515]">
                  Подробнее о правилах и условиях начисления бонусных баллов вы
                  можете узнать в{' '}
                </span>

                <span className="text-[#0788f1]">
                  правилах бонусной программы
                </span>

                <span className="text-[#151515]">
                  {'  '}или при обращении в{' '}
                </span>

                <span className="text-[#0788f1]">поддержку</span>

                <span className="text-[#151515]">.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
